import React from 'react';
import './style.scss';
import CommentTextArea from './comment-textarea';
import LabelSpan from './labelSpan';

const CollaboratorComments = ({ user, id, pdm, comment, isInactivated }) => {
  const canEdit = (pdm === user.login || user.profile === 'BP') && !isInactivated;

  return (
    <div>
      {canEdit ? <CommentTextArea id={id} comment={comment} /> : <LabelSpan comment={comment}/>}
    </div>
  );
};

export default CollaboratorComments;